import React from 'react'
import EmailVerificationEnvelopeIllustration from './EmailVerificationEnvelopeIllustration'

const EmailVerificationPrimaryOffer = (props) => {
  const {
    email, onSendCode, onDifferentEmail, onRemindLater, remindLoading,
  } = props

  return (
    <div className='emailVerificationFlow-primaryOffer'>
      <EmailVerificationEnvelopeIllustration />
      <div className='emailVerificationFlow-title'>Please verify your email address</div>
      <div className='emailVerificationFlow-description'>
        A verified email is what lets you regain access if you lose your password.
      </div>
      <div className='emailVerificationFlow-emailBox'>
        <div className='emailVerificationFlow-emailBox-label'>Email</div>
        <div className='emailVerificationFlow-emailDisplay'>{email}</div>
      </div>
      <button type='button' className='btn btn--blue btn--large' onClick={onSendCode}>
        Verify
      </button>
      <div className='emailVerificationFlow-primaryOffer-links'>
        <button type='button' className='emailVerificationFlow-linkBtn' onClick={onDifferentEmail}>
          I use a different email now
        </button>
        <button
          type='button'
          className='emailVerificationFlow-linkBtn'
          onClick={onRemindLater}
          disabled={remindLoading}
        >
          Remind me later
        </button>
      </div>
    </div>
  )
}

export default EmailVerificationPrimaryOffer
